import { Routes, Route } from 'react-router-dom';
import { Toaster } from '@/components/ui/toaster';
import { AuthProvider } from '@/contexts/AuthContext';
import Layout from '@/components/Layout';
import HomePage from '@/pages/HomePage';
import LoginPage from '@/pages/LoginPage';

import EmailVerificationPage from '@/pages/EmailVerificationPage';
import StudentSetupPage from '@/pages/StudentSetupPage';
import TestListPage from '@/pages/TestListPage';
import ResultsPage from '@/pages/ResultsPage';
import ProfilePage from '@/pages/ProfilePage';
import TestInstructionsPage from '@/components/TestInstructionsModal';

import EnhancedTestTakingPage from '@/components/EnhancedTestTakingPage';
import ForgotPasswordPage from '@/pages/ForgotPasswordPage';
import ResetPasswordPage from '@/pages/ResetPasswordPage';
import { TestResultsPage } from '@/pages/TestResultsPage';
import { AnalyticsPage } from '@/pages/AnalyticsPage';
import ProtectedRoute from '@/components/ProtectedRoute';

function App() {
  return (
    <AuthProvider>
      <Routes>
        {/* Fullscreen test taking page without layout */}
        <Route path="/test/:testId/take" element={<ProtectedRoute><EnhancedTestTakingPage /></ProtectedRoute>} />
        <Route path="/test/:testId" element={<ProtectedRoute><EnhancedTestTakingPage /></ProtectedRoute>} />

        {/* All other routes with layout */}
        <Route path="/*" element={
          <Layout>
            <Routes>
              <Route path="/login" element={<LoginPage />} />

              <Route path="/verify-email" element={<EmailVerificationPage />} />
              <Route path="/setup" element={<StudentSetupPage />} />
              <Route path="/forgot-password" element={<ForgotPasswordPage />} />
              <Route path="/reset-password" element={<ResetPasswordPage />} />
              <Route path="/" element={<ProtectedRoute><HomePage /></ProtectedRoute>} />
              <Route path="/tests" element={<ProtectedRoute><TestListPage /></ProtectedRoute>} />
              <Route path="/test/:testId/instructions" element={<ProtectedRoute><TestInstructionsPage /></ProtectedRoute>} />

              <Route path="/results" element={<ProtectedRoute><TestResultsPage /></ProtectedRoute>} />
              <Route path="/results/:resultId" element={<ProtectedRoute><ResultsPage /></ProtectedRoute>} />
              <Route path="/analytics" element={<ProtectedRoute><AnalyticsPage /></ProtectedRoute>} />
              <Route path="/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
            </Routes>
          </Layout>
        } />
      </Routes>
      <Toaster />
    </AuthProvider>
  );
}

export default App;
